import React from 'react';

const About: React.FC = () => {
  // Define skill categories
  const skillCategories = [
    {
      title: 'Primary Stack',
      skills: ['C#', '.NET (Core / 8)', 'ASP.NET Core', 'Entity Framework', 'MSSQL']
    },
    {
      title: 'Backend & APIs',
      skills: ['Microservices', 'RESTful APIs', 'LINQ', 'Nginx']
    },
    {
      title: 'Databases',
      skills: ['PostgreSQL', 'MySQL', 'MongoDB', 'Oracle', 'Sybase']
    },
    {
      title: 'Frontend & Web',
      skills: ['React', 'TypeScript', 'JavaScript', 'Blazor', 'Angular', 'Vue', 'Tailwind CSS', 'HTML/CSS']
    },
    {
      title: 'Cloud & DevOps',
      skills: ['Azure', 'Docker', 'CI/CD Pipelines']
    },
    {
      title: 'CMS/DXP',
      skills: ['Optimizely', 'WordPress']
    },
    {
      title: 'Mobile',
      skills: ['Flutter', 'Dart']
    },
    {
      title: 'Additional Languages',
      skills: ['Java', 'C/C++', 'Delphi', 'PHP (Laravel)']
    }
  ];

  return (
    <section id="about" className="py-16 bg-gray-50 dark:bg-gray-800 transition-colors">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-8 text-center">About Me</h2>
        
        <div className="max-w-3xl mx-auto">
          <div className="bg-white dark:bg-gray-700 rounded-lg shadow-lg p-8 mb-8">
            <h3 className="text-2xl font-semibold text-gray-800 dark:text-white mb-4">Hello! 👋</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              I'm a seasoned software architect and developer with over 31 years of experience in crafting robust, 
              enterprise-level applications. For 18 of those years, I was a key engineering leader at Prechart Software, 
              where I was instrumental in designing and building critical systems, including the core APIs, web and 
              mobile portals, and our cloud-based case management platform.
            </p>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              My passion lies in understanding how complex systems operate at an architectural level and then 
              building them. I love decoupling monolithic codebases into efficient microservices and am always 
              exploring new technological trends, from modern .NET frameworks to the exciting potential of AI. I 
              thrive on translating complex business needs into elegant, high-performance code.
            </p>
            <p className="text-gray-600 dark:text-gray-300">
              When I'm not architecting systems, I enjoy mentoring fellow developers and sharing the knowledge I've 
              gained over my career.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-700 rounded-lg shadow-lg p-8">
            <h3 className="text-2xl font-semibold text-gray-800 dark:text-white mb-6">Skills & Technologies</h3>
            
            {skillCategories.map((category, catIndex) => (
              <div key={catIndex} className="mb-6 last:mb-0">
                <h4 className="text-lg font-medium text-gray-700 dark:text-gray-200 mb-3">{category.title}</h4>
                <div className="flex flex-wrap gap-2">
                  {category.skills.map((skill, skillIndex) => (
                    <span
                      key={`${catIndex}-${skillIndex}`}
                      className="px-4 py-2 bg-blue-100 dark:bg-gray-600 text-blue-600 dark:text-gray-100 rounded-full text-sm font-medium"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
